import { useDispatch } from 'react-redux'
import { Outlet } from 'react-router-dom'

// material-ui
import Box from '@mui/material/Box'
import useMediaQuery from '@mui/material/useMediaQuery'
// project imports
import { CssBaseline, styled, Theme, useTheme } from '@mui/material'
import Sidebar from './Sidebar'

// assets
import { IconChevronRight } from '@tabler/icons-react'
import { useEffect } from 'react'
import { setMenu } from '../../../app/features/customization/customizationSlice'
import { useAppSelector } from '../../../app/hooks'
import { authStore, customTheme } from '../../../app/selectedStore'
import { useGetAccountQuery } from '../../../app/services/auth'
import { drawerWidth, drawerWidthMDClose } from '../../../constants'
import menuItems from '../../menu-items'
import Breadcrumbs from '../../ui-component/extended/Breadcrumbs'
import LoadingModal from '../../ui-component/LoadingModal'
import Customization from '../customization'

// Define the type for the props used in Main styled component
interface MainProps {
  theme: Theme
  open: boolean
}

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' && prop !== 'theme' })<MainProps>(
  ({ theme, open }) => ({
    ...theme.typography.mainContent,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    transition: theme.transitions.create(
      'margin',
      open
        ? {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
          }
        : {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
          }
    ),
    [theme.breakpoints.up('md')]: {
      marginLeft: 0,
      width: `calc(100% - ${open ? drawerWidth : drawerWidthMDClose}px)`
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      width: '100%'
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      width: '100%'
    }
  })
)

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const { isLoading, refetch } = useGetAccountQuery({})
  const auth = useAppSelector(authStore)
  const theme = useTheme()
  const matchDownMd = useMediaQuery(theme.breakpoints.down('md'))
  // Handle left drawer
  const leftDrawerOpened = useAppSelector(customTheme).opened
  const dispatch = useDispatch()
  const handleLeftDrawerToggle = () => {
    dispatch(setMenu({ opened: !leftDrawerOpened }))
  }

  useEffect(() => {
    if (auth.accessToken) {
      refetch()
      // const newUuid = uuid()
      // dispatch(setUuid(newUuid))
    }
  }, [auth.accessToken])

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      {/* drawer */}
      <Sidebar drawerOpen={!matchDownMd ? leftDrawerOpened : !leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} />

      {/* main content */}
      <Main theme={theme} open={leftDrawerOpened}>
        {/* breadcrumb */}
        <Breadcrumbs separator={IconChevronRight} navigation={menuItems} icon title rightAlign />
        <Outlet />
      </Main>
      <Customization />
      <LoadingModal open={isLoading} />
    </Box>
  )
}

export default MainLayout
